import {OrderDirectionType, SortUiState} from './SortUiState.model';

export class OfferingDeckEngagementUiState {
  private static ORDER_BY_DEFAULT = 'name';
  private static DIRECTION_DEFAULT: OrderDirectionType = 'asc';

  public sort: SortUiState;

  constructor() {
    this.sort = {
      orderBy: OfferingDeckEngagementUiState.ORDER_BY_DEFAULT,
      direction: OfferingDeckEngagementUiState.DIRECTION_DEFAULT
    };
  }

  static fromJson(engagementObj: any): OfferingDeckEngagementUiState {
    const model = new OfferingDeckEngagementUiState();
    if (engagementObj && engagementObj.sort) {
      model.sort = {
        orderBy: engagementObj.sort.orderBy || engagementObj.ORDER_BY_DEFAULT,
        direction: engagementObj.sort.direction || engagementObj.DIRECTION_DEFAULT
      };
    }
    return model;
  }
}
